'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchEvent = exports.eventMap = exports.props = exports.EVENT_DESKPROWINDOW_DOM_QUERY = exports.EVENT_DESKPROWINDOW_DOM_INSERT = exports.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = undefined;

var _Event = require('../Core/Event');

/**
 * @readonly
 * @type {string}
 */
var EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = exports.EVENT_DESKPROWINDOW_SHOW_NOTIFICATION = 'deskpro_window.show_notification';

/**
 * @readonly
 * @type {string}
 */
/**
 * Defines events and related functionality which enable interaction with the helpdesk Window and DOM
 *
 * The events defined in this module give the application the following capabilities:
 *
 *  - insert arbitrary DOM nodes into the helpdesk window
 *  - query the DOM of the helpdesk window
 *  - show a notification in the helpdesk window
 *
 * @module DeskproWindow/events
 */

var EVENT_DESKPROWINDOW_DOM_INSERT = exports.EVENT_DESKPROWINDOW_DOM_INSERT = 'deskpro_window.dom_insert';

/**
 * @readonly
 * @type {string}
 */
var EVENT_DESKPROWINDOW_DOM_QUERY = exports.EVENT_DESKPROWINDOW_DOM_QUERY = 'deskpro_window.dom_query';

/**
 * @type {{EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: {channelType: string, invocationType: string}, EVENT_DESKPROWINDOW_DOM_INSERT: {channelType: string, invocationType: string}, EVENT_DESKPROWINDOW_DOM_QUERY: {channelType: string, invocationType: string}}}
 */
var events = {
  EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET },
  EVENT_DESKPROWINDOW_DOM_INSERT: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_DESKPROWINDOW_DOM_QUERY: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @readonly
 * @enum
 * @type {{EVENT_DESKPROWINDOW_SHOW_NOTIFICATION: {channelType: string, invocationType: string}, EVENT_DESKPROWINDOW_DOM_INSERT: {channelType: string, invocationType: string}, EVENT_DESKPROWINDOW_DOM_QUERY: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * The map of events
 *
 * @type {EventMap}
 */
var eventMap = exports.eventMap = (0, _Event.buildMap)(events, props);

/**
 * Checks if an event is a DeskproWindow event
 *
 * @function
 *
 * @param {string} eventName
 * @param {string} channelType
 * @param {string} invocationType
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, _ref) {
  var channelType = _ref.channelType,
      invocationType = _ref.invocationType;
  return (0, _Event.matchEvent)(eventName, { channelType: channelType, invocationType: invocationType }, eventMap);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/DeskproWindow/events.js
// module id = 163
// module chunks = 0